module.exports = __webpack_public_path__ + "img/mockup1.a29f03a0.png";